import * as e from "react";
const t = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9 2a1 1 0 01.7 1.7L8.13 5.3h-.01l2.37 2.36A11.99 11.99 0 0112 9.508c.437-.66.942-1.28 1.51-1.848l2.37-2.37-1.59-1.58A1 1 0 0115 2h6a1 1 0 011 1v6a1 1 0 01-1.7.7l-1.6-1.58-2.36 2.37A8 8 0 0014 16.14V21a1 1 0 01-.883.993L13 22h-2a1 1 0 01-1-1v-4.86a8 8 0 00-2.34-5.65L5.29 8.12 3.71 9.71A1 1 0 012 9V3a1 1 0 011-1h6z",
      fill: "#2d6ded"
    }
  )
);
export {
  t as default
};
